/**
 * Fragment de routes du paquet v2-p08-ecrans-propriete (vague V2), rendu par le registre v10. Composants chargés à la
 * demande (règle de chargement du registre). Routes neuves (aucune route du socle n'est remplacée) :
 *  - `/org/propriete` → organisation-propriete ;
 *  - `/org/propriete/transferer` (`?destinataire=` depuis la fiche d'un membre) → dialogue-transferer-propriete ;
 *  - `/programme/propriete/transferer?programme=…` → dialogue-transferer-propriete-programme ;
 *  - `/projet/propriete/transferer?projet=…` → dialogue-transferer-propriete-projet.
 */
import { lazy, Suspense, type ComponentType, type JSX } from 'react'

import type { Session } from '../../auth/session'
import type { ContexteRoutes, FragmentRoutes } from './registre'

const OrganisationPropriete = lazy(() => import('../ecrans/v2/propriete/OrganisationPropriete'))
const DialogueTransfererPropriete = lazy(() => import('../ecrans/v2/propriete/DialogueTransfererPropriete'))
const DialogueTransfererProprieteProgramme = lazy(() => import('../ecrans/v2/propriete/DialogueTransfererProprieteProgramme'))
const DialogueTransfererProprieteProjet = lazy(() => import('../ecrans/v2/propriete/DialogueTransfererProprieteProjet'))

function ecran(Composant: ComponentType<{ session: Session }>) {
  return ({ session, t }: ContexteRoutes): JSX.Element => (
    <Suspense fallback={<p role="status">{t('v10.primitives.assemblage.chargement')}</p>}>
      <Composant session={session} />
    </Suspense>
  )
}

export const fragment: FragmentRoutes = {
  zone: 'v2-propriete',
  routes: [
    { chemin: '/org/propriete', element: ecran(OrganisationPropriete) },
    { chemin: '/org/propriete/transferer', element: ecran(DialogueTransfererPropriete) },
    { chemin: '/programme/propriete/transferer', element: ecran(DialogueTransfererProprieteProgramme) },
    { chemin: '/projet/propriete/transferer', element: ecran(DialogueTransfererProprieteProjet) },
  ],
}
